<template>
  <div class="row mt-4" v-if="campanas.length">
    <div class="col-12">
      <div class="card ficha-listado mb-4">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0 panel-section-title">Campañas</h6>
              <p class="text-xs opacity-7 mb-0">Total: <b>{{ campanas.length }}</b></p>
            </div>
            <label class="d-flex align-items-center gap-2 mb-0" style="cursor:pointer;font-size:0.85rem;">
              <input type="checkbox" :checked="mostrarBorrados" @change="$emit('update:mostrarBorrados', $event.target.checked)" style="accent-color:var(--q-gold);" />
              Mostrar campañas borradas
            </label>
            <div class="totales-pill">
              <span>Entradas: <b>{{ resumen.entradas_total }}</b></span>
              <span>Entradas únicas a los canales: <b>{{ resumen.entradas_unicas_total }}</b></span>
              <span>Suscritos al canal: <b>{{ resumen.suscritos_actuales_total }}</b></span>
              <span>Compras: <b>{{ resumen.compras_total }}</b></span>
              <template v-if="resumen.importe_total_eur > 0 || resumen.importe_total_usd > 0">
                <span v-if="resumen.importe_total_eur > 0">EUR: <b>{{ formatMoney(resumen.importe_total_eur, 'EUR') }}</b></span>
                <span v-if="resumen.importe_total_usd > 0">USD: <b>{{ formatMoney(resumen.importe_total_usd, 'USD') }}</b></span>
              </template>
              <span v-else>Importe: <b>{{ formatMoney(resumen.importe_total, 'EUR') }}</b></span>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-flush table-listado table-empirulada">
              <thead class="thead-light">
                <tr>
                  <th :class="['th-sort', thSortClass('fecha')]" @click="sortBy('fecha')">Fecha</th>
                  <th :class="['th-sort', thSortClass('campana_nombre')]" @click="sortBy('campana_nombre')">Campaña</th>
                  <th :class="['th-sort', thSortClass('canal_nombre')]" @click="sortBy('canal_nombre')">Canal</th>
                  <th :class="['th-sort','text-center', thSortClass('entradas')]" @click="sortBy('entradas')">Entradas</th>
                  <th :class="['th-sort','text-center', thSortClass('entradas_unicas')]" @click="sortBy('entradas_unicas')">Entradas únicas a los canales</th>
                  <th :class="['th-sort','text-center', thSortClass('suscritos')]" @click="sortBy('suscritos')">Suscritos al canal</th>
                  <th :class="['th-sort','text-center', thSortClass('compras')]" @click="sortBy('compras')">Compras</th>
                  <th :class="['th-sort','text-end', thSortClass('importe')]" @click="sortBy('importe')">Importe (EUR / USD)</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="c in campPageRows" :key="c.campana_id" :class="{ 'fila-borrada': c.borrada }">
                  <td>{{ fmtFechaDMY(c.fecha) }}</td>
                  <td>
                    <div class="campana-nombre">
                      {{ c.campana_nombre || '-' }}
                      <span v-if="c.borrada" class="badge-borrada ms-2">Borrada</span>
                    </div>
                  </td>
                  <td><div class="canal-sub">{{ c.canal_nombre }}</div></td>
                  <td class="text-center">{{ c.metricas?.entradas_total ?? 0 }}</td>
                  <td class="text-center">{{ c.metricas?.entradas_unicas ?? 0 }}</td>
                  <td class="text-center">{{ c.metricas?.suscritos_actuales ?? 0 }}</td>
                  <td class="text-center">{{ c.metricas?.compras ?? 0 }}</td>
                  <td class="text-end">
                    <template v-if="(c.metricas?.importe_eur ?? 0) > 0 || (c.metricas?.importe_usd ?? 0) > 0">
                      <div v-if="(c.metricas?.importe_eur ?? 0) > 0">{{ formatMoney(c.metricas.importe_eur, 'EUR') }}</div>
                      <div v-if="(c.metricas?.importe_usd ?? 0) > 0" class="text-xs opacity-8">{{ formatMoney(c.metricas.importe_usd, 'USD') }}</div>
                    </template>
                    <template v-else>{{ formatMoney(c.metricas?.importe ?? 0, 'EUR') }}</template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginación campañas -->
          <div v-if="campTotalPages > 1" class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-3">
            <p class="text-xs opacity-7 mb-0">{{ campFrom }}-{{ campTo }} de {{ campanas.length }}</p>
            <div class="btn-group">
              <button class="btn btn-sm btn-pagi mb-0" :disabled="campPage <= 1" @click="campPage = 1">«</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="campPage <= 1" @click="campPage--">‹</button>
              <button class="btn btn-sm btn-pagi mb-0" disabled>{{ campPage }} / {{ campTotalPages }}</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="campPage >= campTotalPages" @click="campPage++">›</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="campPage >= campTotalPages" @click="campPage = campTotalPages">»</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelTipsterCampanas",
  emits: ['update:mostrarBorrados'],
  props: {
    campanas: { type: Array, default: () => [] },
    resumen: { type: Object, required: true },
    mostrarBorrados: { type: Boolean, default: false },
  },
  data() {
    return {
      campPage: 1,
      campPerPage: 10,
      sortCol: 'fecha',
      sortDir: 'desc',
    };
  },
  computed: {
    campSorted() {
      const arr = [...this.campanas];
      if (!this.sortCol) return arr;
      const dir = this.sortDir === 'asc' ? 1 : -1;
      return arr.sort((a, b) => {
        let va, vb;
        switch (this.sortCol) {
          case 'fecha':          va = a.fecha || '';             vb = b.fecha || '';             break;
          case 'campana_nombre': va = (a.campana_nombre || '').toLowerCase(); vb = (b.campana_nombre || '').toLowerCase(); break;
          case 'canal_nombre':   va = (a.canal_nombre || '').toLowerCase();   vb = (b.canal_nombre || '').toLowerCase();   break;
          case 'entradas':       va = a.metricas?.entradas_total ?? 0;  vb = b.metricas?.entradas_total ?? 0;  break;
          case 'entradas_unicas':va = a.metricas?.entradas_unicas ?? 0; vb = b.metricas?.entradas_unicas ?? 0; break;
          case 'suscritos':      va = a.metricas?.suscritos_actuales ?? 0; vb = b.metricas?.suscritos_actuales ?? 0; break;
          case 'compras':        va = a.metricas?.compras ?? 0;  vb = b.metricas?.compras ?? 0;  break;
          case 'importe':        va = a.metricas?.importe ?? 0;  vb = b.metricas?.importe ?? 0;  break;
          default: return 0;
        }
        if (va < vb) return -dir; if (va > vb) return dir; return 0;
      });
    },
    campTotalPages() { return Math.max(1, Math.ceil(this.campSorted.length / this.campPerPage)); },
    campPageRows() {
      const start = (this.campPage - 1) * this.campPerPage;
      return this.campSorted.slice(start, start + this.campPerPage);
    },
    campFrom() { return this.campSorted.length === 0 ? 0 : (this.campPage - 1) * this.campPerPage + 1; },
    campTo() { return Math.min(this.campPage * this.campPerPage, this.campSorted.length); },
  },
  watch: {
    campanas() { this.campPage = 1; },
    sortCol() { this.campPage = 1; },
  },
  methods: {
    sortBy(col) {
      if (this.sortCol === col) { this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'; }
      else { this.sortCol = col; this.sortDir = ['campana_nombre','canal_nombre'].includes(col) ? 'asc' : 'desc'; }
    },
    thSortClass(col) { return this.sortCol === col ? this.sortDir : ''; },
    formatMoney(n, currency = 'EUR') {
      return Number(n || 0).toLocaleString("es-ES", { style: "currency", currency });
    },
    fmtFechaDMY(fechaStr) {
      if (!fechaStr) return "";
      const onlyDate = String(fechaStr).split(" ")[0].split("T")[0];
      const [y, m, d] = onlyDate.split("-");
      return (y && m && d) ? `${d}-${m}-${y}` : onlyDate;
    },
  },
};
</script>

<style scoped>
.th-sort { cursor: pointer; user-select: none; white-space: nowrap; }
.th-sort:hover { color: var(--q-gold); }

.totales-pill {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  font-size: 12px;
  opacity: .85;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  padding: 10px 12px;
  border-radius: 12px;
}
.fila-borrada { opacity: .75; }
.campana-nombre { font-weight: 700; color: var(--q-text); line-height: 1.15; }
.canal-sub { font-size: 12px; opacity: .75; line-height: 1.15; }

.table-empirulada { border-collapse: separate !important; border-spacing: 0 10px; }
.table-empirulada thead th { border: 0 !important; background: var(--q-hover); color: var(--q-text); font-weight: 700; padding: 12px 14px; }
.table-empirulada tbody tr { background: var(--q-card-alt); box-shadow: 0 6px 18px rgba(0,0,0,.06); }
.table-empirulada tbody td { border: 0 !important; padding: 12px 14px; vertical-align: middle; }
.table-empirulada > :not(caption) > * > * { border-bottom-width: 0 !important; }
.table-empirulada tbody tr:hover { transform: translateY(-1px); transition: .15s ease; }
.table-empirulada tbody tr td:first-child { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }
.table-empirulada tbody tr td:last-child { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }
.table-empirulada tbody tr { overflow: hidden; }
.table-empirulada thead, .table-empirulada thead tr, .table-empirulada thead th { border-radius: 0 !important; }
.table-empirulada thead th:first-child, .table-empirulada thead th:last-child {
  border-top-left-radius: 0 !important; border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important;
}
.table-empirulada thead tr { box-shadow: none !important; background: transparent !important; }

.badge-borrada {
  display: inline-block; padding: 2px 8px; border-radius: 20px;
  font-size: 10px; font-weight: 700;
  background: var(--q-hover); color: var(--q-muted); border: 1px solid var(--q-border-md);
}
.btn-pagi {
  background: var(--q-card-alt); border: 1px solid var(--q-border-md);
  color: var(--q-muted); padding: 4px 10px; font-size: 0.8rem; transition: .15s;
}
.btn-pagi:hover:not(:disabled) { background: var(--q-hover); color: var(--q-gold); border-color: var(--q-gold); }
.btn-pagi:disabled { opacity: .4; cursor: not-allowed; }
</style>
